"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function AiDotSvg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 40, height: 30, viewBox: "0 0 40 30", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("g", { id: "dot", filter: "url(#filter0_dd_1387_4345)" },
            react_1.default.createElement("circle", { cx: 3.00005, cy: 3.00005, r: 3.00005, transform: "matrix(1 0 0 -1 23.9999 18)", fill: "#5E30E3" })),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("filter", { id: "filter0_dd_1387_4345", x: -0.00012207, y: -12, width: 54.0001, height: 54.0001, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
                react_1.default.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                react_1.default.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
                react_1.default.createElement("feOffset", null),
                react_1.default.createElement("feGaussianBlur", { stdDeviation: 12 }),
                react_1.default.createElement("feComposite", { in2: "hardAlpha", operator: "out" }),
                react_1.default.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.368627 0 0 0 0 0.188235 0 0 0 0 0.890196 0 0 0 0.15 0" }),
                react_1.default.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_1387_4345" }),
                react_1.default.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
                react_1.default.createElement("feMorphology", { radius: 2.5, operator: "dilate", in: "SourceAlpha", result: "effect2_dropShadow_1387_4345" }),
                react_1.default.createElement("feOffset", null),
                react_1.default.createElement("feComposite", { in2: "hardAlpha", operator: "out" }),
                react_1.default.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.937255 0 0 0 0 0.917647 0 0 0 0 0.988235 0 0 0 1 0" }),
                react_1.default.createElement("feBlend", { mode: "normal", in2: "effect1_dropShadow_1387_4345", result: "effect2_dropShadow_1387_4345" }),
                react_1.default.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect2_dropShadow_1387_4345", result: "shape" }))));
}
function AiDot(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(AiDotSvg, Object.assign({}, svgProps)));
}
exports.default = AiDot;
//# sourceMappingURL=AiDot.js.map